import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { heroData } from "../../../mocks/homeData";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative h-[480px] md:h-[620px] lg:h-[720px] overflow-hidden">
      <img
        src={heroData.image}
        alt="横浜夜景ヘリコプター遊覧"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-airdoa-navy/70 via-airdoa-navy/20 to-airdoa-navy/60" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <p className="text-xs md:text-sm tracking-ultra text-airdoa-gold mb-4 md:mb-5 animate-fade-in">
          {t("home.hero.badge")}
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-[1.3] whitespace-pre-line animate-slide-up animation-delay-200">
          {t("home.hero.title")}
        </h1>
        <p className="mt-5 md:mt-6 max-w-2xl text-sm md:text-base text-white/80 leading-relaxed animate-slide-up animation-delay-300">
          {t("home.hero.subtitle")}
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-3 md:gap-4 animate-slide-up animation-delay-400">
          <Link to={heroData.ctaPrimary.href} className="btn-primary">
            {t("home.hero.ctaPrimary")}
          </Link>
          <Link to={heroData.ctaSecondary.href} className="btn-ghost">
            {t("home.hero.ctaSecondary")}
          </Link>
        </div>
      </div>
    </section>
  );
}
